import React from "react";
import { Flex, Anchor } from "@ebscois/react-component-library";
import { useConfig } from "@eis-poc/lib-discover-medical-mfes";
import { StyledNoAccountParagraph } from "./MfeRouteFallback.styled";
import { logUnauthorizedViewed, logEvent } from "../../../utils/analytics";
import CallToAction from "../../CallToAction";
import { isAuthenticated } from "../../../utils/authUtils";
import { appendReturnToUrl } from "../../../utils/returnToUrlClickHandler";

const MfeRouteFallback = () => {
  const configContextData = useConfig();

  if (!isAuthenticated(configContextData)) {
    const signInUrl =
      configContextData?.productInfo?.productRelativePathUrls?.signInUrl ||
      "/dha";
    logEvent(logUnauthorizedViewed);
    return (
      <div data-testid="no-access">
        We're sorry! You do not have permission to access this page.
        <StyledNoAccountParagraph element="p" color="black">
          Have an account?{" "}
          <Anchor href={appendReturnToUrl(signInUrl)}>Sign in</Anchor>
        </StyledNoAccountParagraph>
      </div>
    );
  }

  const ctaMessages = configContextData?.ctas?.generic;

  return (
    <Flex.Content className="mfew-Cta-container">
      <Flex
        data-testid="cta-messages"
        column
        cell
        align={{ content: "center", item: "center" }}
        justify={{ content: "center" }}
      >
        <CallToAction cta={ctaMessages} />
      </Flex>
    </Flex.Content>
  );
};

MfeRouteFallback.displayName = "MfeRouteFallback";
export default MfeRouteFallback;
